<template>
    <div class="lightspeed-integration-overview">
        <LightspeedConfiguration />
    </div>
</template>

<script>
import LightspeedConfiguration from '@/components/organisms/Lightspeed/LightspeedConfiguration.vue';

export default {
    name: 'LightspeedIntegrationOverview',
    components: {
        LightspeedConfiguration,
    },
    data() {
        return {
            shopId: new URLSearchParams(document.location.search).get('shop_id'),
            shopLanguage: new URLSearchParams(document.location.search).get('language'),
            shopLanguages: undefined,
            clientId: undefined,
        };
    },
};
</script>

<style scoped lang="scss">
    @import "./src/style_variables/style_variables";
    .lightspeed-integration-overview {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        grid-gap: 96px;
        grid-auto-rows: min-content;
        width: 100%;
        min-height: calc(100vh - 68px);
        max-width: 792px;
        background-color: $white;
        border-top-left-radius: 24px;
        border-top-right-radius: 24px;
        box-shadow: 0 10px 20px 0 rgba(30, 30, 30, 0.05);
        overflow: hidden;
        @media (max-width: 769px) {
            padding: 16px 8px;
            margin: -4px auto 0px auto;
        }
        @media (min-width: 768px) {
            padding: 92px 48px 48px;
            margin: -72px auto 0px auto;
        }
    }
</style>
